export default __webpack_public_path__ + "static/media/arweave-ar-logo.b7ea53d0.svg";